/**
 * Logo scroll swap (mobile + desktop)
 * Top of page  → full logo (heading + signature)
 * After scroll → signature logo only
 *
 * Uses Prestige `.is-solid` (scroll tracker) + scrollY fallback
 * so it works in the theme editor and on mobile/desktop.
 */
(function () {
  var header = null;
  var threshold = 8;
  var ticking = false;

  function getScrollY() {
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function update() {
    if (!header) return;

    var scrolled =
      header.classList.contains('is-solid') || getScrollY() > threshold;

    header.classList.toggle('is-logo-scrolled', scrolled);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      update();
      ticking = false;
    });
  }

  function init() {
    header = document.querySelector('x-header.header, .header');
    if (!header) return;
    if (!header.querySelector('.header__logo-image--transparent')) return;

    update();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });

    // Prestige toggles `.is-solid` via IntersectionObserver — mirror it
    new MutationObserver(update).observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    header = null;
    init();
  });
})();
